import SimpleMemoization from "./simple_memoization.js";
export var CsgOperationType;
(function (CsgOperationType) {
    CsgOperationType[CsgOperationType["UNION"] = 0] = "UNION";
    CsgOperationType[CsgOperationType["INTERSECTION"] = 1] = "INTERSECTION";
    CsgOperationType[CsgOperationType["DIFFERENCE"] = 2] = "DIFFERENCE";
    CsgOperationType[CsgOperationType["NEGATION"] = 3] = "NEGATION";
})(CsgOperationType || (CsgOperationType = {}));
/**
 * CSG Memoization
 */
export class CsgMemoization extends SimpleMemoization {
    /**
     * Updates simple memoization
     */
    constructor() {
        super();
    }
}
